import { isFunction } from 'formik';
import React from 'react';

let navigator = null;

export default (() => {
    function push(url, target = null) {
        if (url.match(/^http.*/)) {
            // Reload page if link is external to application
            if (target === '_blank') {
                window.open(url, target);
            } else {
                window.location = url;
            }
        } else {
            navigator.push(url);
        }
    }

    function canGoBack() {
        return navigator.length > 1;
    }

    function back(fallback) {
        if (canGoBack()) {
            return navigator.goBack();
        }

        if (fallback && isFunction(fallback)) {
            return fallback();
        }

    }

    function setNavigator(elem) {
        if (navigator === null) {
            navigator = elem;
        }
    }

    return {
        push,
        back,
        canGoBack,
        setNavigator,
    };
})();
